module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/jibunehon_giftcode_07-9534109567443807d9654f9a02814665.png";